export default {"src":"/_next/static/media/send_invite.fd0a2353.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};